import { useMobileDetect } from '../../../hooks';

import { Box, Typography, LinearProgress, CircularProgress } from '@mui/material';

export function ProgressBar({ value }) {
    const isMobile = useMobileDetect();

    const roundedValue = Math.round(value);

    const color = getProgressColor(roundedValue);

    if (isMobile) {
        return <CircularProgressBar value={roundedValue} color={color} />;
    }
    
    return <LinearProgressBar value={roundedValue} color={color} />;
};

export const getProgressColor = (value) => {
    if (value <= 0) {
        return 'var(--grey-400-color)';
    } else if (value < 100) {
        return 'var(--warning-color)';
    } else if (value >= 100) {
        return 'var(--success-color)';
    }

    return 'var(--error-color)';
};

const LinearProgressBar = ({value, color}) => (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <Box sx={{ width: '100%', mr: 1 }}>
            <LinearProgress
                variant="determinate"
                value={value}
                sx={{
                    width: 160,
                    height: 15,
                    borderRadius: 5,
                    backgroundColor: 'var(--grey-400-color)',
                    '& .MuiLinearProgress-bar': {
                        backgroundColor: color,
                    },
                }}
            />
        </Box>

        <Box
            sx={{
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: 'absolute',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Typography
                variant="button"
                color="text.secondary"
                sx={{
                    fontWeight: '900',
                    lineHeight: 1,
                    color: 'var(--black-color)',
                    fontSize: '0.775rem',
                }}
            >
                {`${value}%`}
            </Typography>
        </Box>
    </Box>
);

const CircularProgressBar = ({ value, color }) => (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
            variant="determinate"
            sx={{ color: 'var(--grey-400-color)' }}
            thickness={5}
            size={50}
            value={100}
        />
        <CircularProgress
            variant="determinate"
            sx={{
                color: color,
                position: 'absolute',
                left: 0,
            }}
            thickness={5}
            size={50}
            value={value}
        />
        <Box
            sx={{
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: 'absolute',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Typography
                variant="caption"
                color="text.secondary"
                sx={{
                    fontWeight: '900',
                    lineHeight: 1,
                    color: 'var(--black-color)',
                    fontSize: '0.775rem',
                }}
            >
                {`${value}%`}
            </Typography>
        </Box>
    </Box>
);
